//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            default: () => ''
        },
        hideCheckbox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            check: false
        }
    },
    mounted() {
        this.check = this.value === true ? true : false
    },
    methods: {
        setCheck(param) {
            this.check = param
        },
        handleClick() {
            this.check = !this.check
            this.$emit('input', this.check)
        }
    }
}
